export default {"src":"/_next/static/media/tm.c78ae814.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};